<template>
  <v-content>
    <v-container class="fill-height" fluid>
      <v-overlay color="grey lighten-2" :value="true">
        <div class="text-center mb-5">
          <img :src="logo" alt="Logo" width="150" />
        </div>

        <div class="text-center">
          <v-progress-circular :size="120" color="red" indeterminate>
            <span style="font-size: 10pt; font-weight: bold"
              >Analisando Dados...</span
            >
          </v-progress-circular>
        </div>
      </v-overlay>
    </v-container>
  </v-content>
</template>
<script>
export default {
  name: "lineChartLoader",

  data() {
    return {
      logo: "/img/Logo.png"
    };
  }
};
</script>
